<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData.data.parkir_oku }}</pre>  -->
  <Background v-if=" parkirOku && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PENYALAHGUNAAN PARKIR OKU.png"
        alt="PENYALAHGUNAAN PARKIR OKU"
        class="pbt-image"
      >

      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <h2> PARKIR OKU</h2>

      <div class="content-wrapper">
        <div class="oku-row">
   
          <div class="oku-image-container">
            <img
              src="@/assets/oku/saman.png"
              alt="First Image"
            >
          </div>

          <div class="oku-text-container">

            <div class="oku-text-box">
              <img
                src="@/assets/oku/kotak.png"
                alt="Text Background"
              >
              <div class="text">
                <h3>BILANGAN KES PENYALAHGUNAAN PARKIR OKU</h3>
                <p><span class="value number">{{ parkirOku.bilangan_kes_penyalahgunaan_parkir_oku }}</span></p>
              </div>
            </div>

            <div class="oku-text-box">
              <img
                src="@/assets/oku/kotak.png"
                alt="Text Background"
              >
              <div class="text">
                <h3>JUMLAH KOMPAUN</h3>
                <p><span class="value number">RM{{ numberWithCommas(parkirOku.jumlah_kompaun_rm) }}</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from '@/components/background/background.vue'
import Menu from '@/components/menu-items/utama-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()


const parkirOku = ref({
  parkirOku: {
    // eslint-disable-next-line camelcase
    bilangan_kes_penyalahgunaan_parkir_oku: 0,
    // eslint-disable-next-line camelcase
    jumlah_kompaun_rm: 0,
  },

})

const responseData = ref(null)


async function  loadDataFromApi(){
  try {
    const response = await httpGet('kejuruteraan-awam/oku')


    responseData.value = response
    parkirOku.value = response.data.parkir_oku.data

   
    parkirOku.value.parkirOku = {
      // eslint-disable-next-line camelcase
      bilangan_kes_penyalahgunaan_parkir_oku: parkirOku.value && parkirOku.value.bilangan_kes_penyalahgunaan_parkir_oku ? this.numberWithCommas(parkirOku.value.bilangan_kes_penyalahgunaan_parkir_oku) : 0,
      // eslint-disable-next-line camelcase
      jumlah_kompaun_rm: this.numberWithCommas(parkirOku.value && parkirOku.value.jumlah_kompaun_rm ? parkirOku.value.jumlah_kompaun_rm.toFixed(2) : 0.00),
    }


  } catch (err) {
    console.error('loadDataFromApi failed:', err)
  } 
}


onMounted(() => {
  loadDataFromApi()
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px;
  text-align: left;
  width: 100%;
}

.oku-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  width: 100%;
  flex-wrap: wrap;
}

.oku-image-container,
.oku-text-container {
  width: 48%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.oku-image-container img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.oku-text-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.oku-text-box {
  position: relative;
  margin-bottom: 20px;
}

.oku-text-box img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #150069;
  z-index: 1;
  width: 100%;
}

h3 {
  font-size: 1.5rem;
  color: #150069;
}

.value {
  font-size: 2.5rem;
  color: #a80000;
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  .oku-row {
    flex-direction: column;
    align-items: center;
  }

  .oku-image-container,
  .oku-text-container {
    width: 100%;
  }

  h2 {
    font-size: 1.3rem;
  }

  h3 {
    font-size: 1.1rem;
  }

  .value {
    font-size: 1.8rem;
  }
}

@media screen and (max-width: 480px) {
  h2 {
    font-size: 1.2rem;
  }

  h3 {
    font-size: 1rem;
  }

  .value {
    font-size: 1.5rem;
  }
}
</style>
